import { render } from "./HotelsForm.vue?vue&type=template&id=d16062be&scoped=true"
import script from "./HotelsForm.vue?vue&type=script&lang=js"
export * from "./HotelsForm.vue?vue&type=script&lang=js"

import "./HotelsForm.vue?vue&type=style&index=0&id=d16062be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d16062be"]])

export default __exports__